import { render } from "./Avatar.vue?vue&type=template&id=4097d401"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import "./Avatar.vue?vue&type=style&index=0&id=4097d401&lang=css"
script.render = render

export default script